import { render, staticRenderFns } from "./TaxertResolves.vue?vue&type=template&id=382f3516&scoped=true&"
import script from "./TaxertResolves.vue?vue&type=script&lang=js&"
export * from "./TaxertResolves.vue?vue&type=script&lang=js&"
import style0 from "./TaxertResolves.vue?vue&type=style&index=0&id=382f3516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f3516",
  null
  
)

export default component.exports